const NO_PERMISSION_STATUS = 403;

export { NO_PERMISSION_STATUS };
